import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { Icons } from "src/util/enums/fontAwesomeIcons"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxExternal',
  props: {
  href: {
    required: true,
    type: String,
  },
},
  setup(__props) {

const props = __props

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("a", {
    href: props.href,
    target: "_blank",
    class: "button-big"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createTextVNode(" "),
    _createVNode(_component_q_icon, {
      name: _unref(Icons).EXTERNAL_LINK
    }, null, 8, ["name"])
  ], 8, _hoisted_1))
}
}

})